// Events
import { ANNOUNCEMENT_HIDE, UPDATE_VISIBLE_SCREEN_HEIGHT } from 'events';
import Cookies from 'js-cookie';
import { component } from 'picoapp';
import Swiper, { Autoplay, Manipulation, Mousewheel } from 'swiper';

import { setCSSProperty } from 'utils/css';

// Utils
import choozy from 'utils/choozy';

Swiper.use([Autoplay, Manipulation, Mousewheel]);

export default component(async (node, ctx) => {
  const container = node.closest('[data-announcement-container]');
  const { slider, close: closeButtons } = choozy(node);

  const hasCountdown = 'hasCountdown' in slider.dataset;

  const mobileAnimation = JSON.parse(node.dataset.mobileAnimation);
  const desktopAnimation = JSON.parse(node.dataset.desktopAnimation);

  let carousel = null;

  const initSwiper = () => {
    carousel = new Swiper(slider, {
      slideClass: 'swiper-slide-mobile',
      slidesPerView: mobileAnimation.type === 'horizontal_continuous' ? 'auto' : 1,
      speed: mobileAnimation.duration,
      direction: mobileAnimation.type === 'vertical' ? 'vertical' : 'horizontal',
      loop: ['vertical', 'horizontal_delayed'].includes(mobileAnimation.type),
      autoplay:
        mobileAnimation.type !== 'none'
          ? {
              delay: mobileAnimation.delay,
            }
          : { enabled: false },
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        1024: {
          ...(hasCountdown
            ? { autoplay: false }
            : {
                slideClass: 'swiper-slide-desktop',
                slidesPerView: desktopAnimation.type === 'vertical' ? 1 : 'auto',
                speed: desktopAnimation.duration,
                direction: desktopAnimation.type === 'vertical' ? 'vertical' : 'horizontal',
                loop: ['vertical', 'horizontal_delayed'].includes(desktopAnimation.type),
                autoplay:
                  desktopAnimation.type !== 'none'
                    ? {
                        enabled: true,
                        delay: desktopAnimation.delay,
                      }
                    : { enabled: false },
              }),
        },
      },
    });
  };

  const show = () => {
    container.hidden = false;
    setCSSProperty(
      document.documentElement,
      '--announcement-height',
      `${container.offsetHeight}px`,
    );

    ctx.emit(UPDATE_VISIBLE_SCREEN_HEIGHT);

    setTimeout(() => {
      initSwiper();
    }, 0);
  };

  const hide = () => {
    container.hidden = true;
    setCSSProperty(document.documentElement, '--announcement-height', '0px');
    setCSSProperty(document.documentElement, '--header-offset', '0px');

    ctx.emit(UPDATE_VISIBLE_SCREEN_HEIGHT);

    if (carousel === null) return;
    carousel.destroy();
    carousel = null;
  };

  ctx.on(ANNOUNCEMENT_HIDE, hide);

  const initAnnouncement = () => {
    const key = `announcement-${node.dataset.key}`;
    const hasCookie = typeof Cookies.get(key) !== 'undefined';

    if (hasCookie) {
      hide();

      return;
    }

    show();

    closeButtons.forEach((closeButton) =>
      closeButton.addEventListener('click', () => {
        ctx.emit(ANNOUNCEMENT_HIDE);

        Cookies.set(key, true, {
          expires: 7,
        });
      }),
    );
  };

  if (node.children) {
    initAnnouncement();
  }
});
